<div #wrapper
     class="position-relative max-w-100"
     (mousedown)="onMouseDown($event, marker)"
     (mouseup)="onMouseUp($event, marker)"
     (mousemove)="onMouseMove($event, marker)">
    <div #marker
         [ngClass]="{'marker-visible': visible, 'marker-invisible': !visible}"></div>
    <ng-content></ng-content>
</div>
